import type { ReactElement } from 'react';
import type { ObjectValues } from '../types';

export const variants = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
} as const;

export const themes = {
  light: 'light',
  fixed: 'fixed',
} as const;

export enum Types {
  Numerical = 'Numerical',
  Icon = 'Icon',
}

type Icon = {
  type: Types.Icon;
  content: ReactElement;
};

type Numerical = {
  type: Types.Numerical;
  content: number;
};

export type Badge = {
  content: Numerical | Icon;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
};
